import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-string-modal',
  templateUrl: './add-string-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-string-modal.component.scss']
})
export class AddStringModalComponent {
  public wellStringForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  public stringIndicatorList : string[] = [
    'U',
    'L',
    'Single'
  ]
  
  constructor(
    public dialogRef: MatDialogRef<AddStringModalComponent>,
    private wellHeaderInfoService: WellHeaderInfoService,
    @Inject(MAT_DIALOG_DATA) public wellbore: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.wellStringForm = this.initializeForm()

    this.wellStringForm.get('stringShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.wellStringForm.get('stringShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });

    this.wellStringForm.get('stringIndicatorShortName')?.valueChanges.subscribe(value => {
      if (value && value == 'U') {
        this.wellStringForm.get('stringIndicatorLongName')?.setValue('Upper', { emitEvent: false });
      } else if (value && value == 'L') {
        this.wellStringForm.get('stringIndicatorLongName')?.setValue('Lower', { emitEvent: false });
      } else if (value && value == 'Single') {
        this.wellStringForm.get('stringIndicatorLongName')?.setValue('Single', { emitEvent: false });
      }
    });
  }

  initializeForm() {
    return this.fb.group({
      wellId: this.wellbore.wellId,
      wellboreId: this.wellbore.wellboreId,
      stringShortName: ['', [Validators.required, noWhitespaceValidator()]],
      stringLongName: ['', [Validators.required, noWhitespaceValidator()]],
      stringStatus: '',
      stringIndicatorLongName: '',
      stringIndicatorShortName: '',
      reservoirZone: '',
      tubingSize: 0,
      remarks: '',
    })
  }

  createWellString() {
    this.isLoading = true

    this.wellHeaderInfoService.createWellString(this.wellStringForm.value).subscribe(
      {
        next: (res) => {
          if (res.isSuccess) {
            this.isSuccess = true
            this.closeDialog()
          }
        },
        error: (err) => this.isLoading = false
      }
    )
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get stringShortName() {
    return this.wellStringForm.get('stringShortName');
  }

  get stringLongName() {
    return this.wellStringForm.get('stringLongName');
  }
}
